import jLogin from '@/views/login/jLogin';
import jLoginSiswa from '@/views/login-siswa/jLoginSiswa';
import Vue from 'vue';

export default [
  {
    path: '/',
    name: 'jLogin',
    component: jLogin,
    beforeEnter(to, from, next) {
      if (Vue.ls.get('Token')) {
        next('/home');
      } else {
        next();
      }
    },
    meta: {
      title: 'Login Pegawai',
    },
  },
  {
    path: '/siswa',
    name: 'jLoginSiswa',
    component: jLoginSiswa,
    beforeEnter(to, from, next) {
      if (Vue.ls.get('Token')) {
        next('/home-siswa');
      } else {
        next();
      }
    },
    meta: {
      title: 'Login Siswa',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterLogin.js